module.exports = __webpack_public_path__ + "static/media/typesense-search-logo.cb81681a.png";